export const GET_CERTIFICATIONS = 'certifications/GET_CERTIFICATIONS';
export const GET_CERTIFICATIONS_SUCCESS = 'certifications/GET_CERTIFICATIONS_SUCCESS';
export const GET_CERTIFICATIONS_FAILED = 'certifications/GET_CERTIFICATIONS_FAILED';